export default __webpack_public_path__ + "static/media/app_cathay.3be70ec3.png";